// removed by extract-text-webpack-plugin
module.exports = {"card-with-period":"card-with-period","chart-period":"chart-period","chart-period-items":"chart-period-items","chart-confirmed-filter":"chart-confirmed-filter","chart-period-item":"chart-period-item","chart-custom-range-tooltip":"chart-custom-range-tooltip"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/dashboard/component/card-with-period/card-with-period.style.sass
// module id = DgF8
// module chunks = 0